/**
 * Map the nested `owner` join from Supabase into flat `owner_name` / `owner_avatar_url`
 * fields expected by the frontend type system.
 */
export function applyOwnerFields<
  T extends {
    owner?: { name?: string | null; avatar_url?: string | null } | null;
    owner_name?: string | null;
    owner_avatar_url?: string | null;
  },
>(row: T) {
  return {
    ...row,
    owner_name: row?.owner?.name || row.owner_name || '',
    owner_avatar_url: row?.owner?.avatar_url ?? row.owner_avatar_url ?? null,
  };
}
